import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "small text-muted" };
const _hoisted_2 = { class: "alert alert-danger mt-2 mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, " Antrag: " + _toDisplayString(_ctx.process.processNumber) + ", " + _toDisplayString(_ctx.process.description), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allMessages, (message) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(message.text), 1));
        }), 256)),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$forms.componentPageName(_ctx.servicePage?.pageType)), {
            process: _ctx.process,
            schema: _ctx.schema,
            data: _ctx.data,
            page: _ctx.servicePage
        }, null, 8, ["process", "schema", "data", "page"]))
    ], 64));
}
